import { computed } from 'vue';
import { usePrice as useBcomPrice } from '@nuxt-common/media-card-large/app/modules/price/composables/usePrice.bcom';
import { usePrice as useMcomPrice } from '@nuxt-common/media-card-large/app/modules/price/composables/usePrice';
import { useLoyalty } from '~/composables/loyalty/useLoyalty';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { useBrand } from '~/composables/useBrand';
import { usePageData } from '~/composables/usePageData';
import useExperiments from '~/stores/useExperimentsStore';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import type { Color, Size } from '~/declaration/traits';

/**
 *  usePrice parity between mcom / bcom
 */
export function usePrice({
  id,
  selectedColor,
  selectedSize,
  selectedUpcId,
}: {
  id: MaybeRef<ProductId>;
  selectedColor: WritableComputedRef<Color | null>;
  selectedSize: WritableComputedRef<Size | null>;
  selectedUpcId: ComputedRef<UpcId | null>;
}) {
  const { isMcom } = useBrand();
  const price = isMcom ? useMcomPrice : useBcomPrice;
  const { shoppingMode, user } = usePageData();
  const { tierName } = useLoyalty();
  const {
    killswitches: { upcPricingForMarketplaceStandardPDPEnabled = false, isPDPEnhancementYEnabled = false },
  } = useKillswitches();
  const {
    experimentFlags: { isGWPEnabled, isGWPEnabled2 },
  } = useExperiments();
  const { isShopTheSetExpEnabled } = useFeatureEligibility();

  const userData = computed(() => ({
    tierName: tierName.value,
    shoppingMode,
    user,
  }));

  return price({
    id,
    selectedColor,
    selectedSize,
    selectedUpc: selectedUpcId,
    userData,
    uiKillswitches: { upcPricingForMarketplaceStandardPDPEnabled, isPDPEnhancementYEnabled },
    isGWPEnabled: isGWPEnabled || isGWPEnabled2,
    isShopTheSetEnabled: isShopTheSetExpEnabled,
  });
}

export default usePrice;
